export default __webpack_public_path__ + "static/media/img8.a611d71e.PNG";